export default __webpack_public_path__ + "static/media/mtn.7e5128e8.png";